import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEntryTracking } from "../../contexts/EntryContext";
import { useTheme } from "../../contexts/ThemeContext";
import LocationMarquee from "./LocationMarquee";
import { CITIES_DATA } from "../../data/citiesData";
import { phoneWhatsapp } from "../../config/phone";

// ===== Ícones =====
const GlobeIcon = () => (
  <svg width="25" height="25" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_723_6728)">
      <path d="M4.65905 3.36828C-4.40599 11.2883 0.793624 26.3268 12.7366 26.9906C13.2594 27.0196 13.7926 26.9689 14.316 26.9906C14.6384 26.9109 14.9989 26.9208 15.3345 26.8779C21.2783 26.1133 26.1121 21.2637 26.8873 15.3291C26.9308 14.9936 26.9195 14.6337 27 14.3107V12.7326C26.3836 1.64848 13.0794 -3.98817 4.65905 3.36828ZM5.47314 4.76046C6.26943 4.02284 7.27468 3.34323 8.26279 2.89367L7.31555 6.20868L4.94777 5.36559C4.89702 5.29704 5.3914 4.83627 5.47314 4.76046ZM3.84299 6.5765C4.84428 7.04057 5.87854 7.44728 6.94575 7.736C6.6623 9.38791 6.49025 11.0556 6.42104 12.7326H1.68417C1.75866 10.5125 2.61691 8.3965 3.84299 6.5765ZM3.84299 20.4667C2.61691 18.6467 1.75866 16.5308 1.68417 14.3107H6.42104C6.49025 15.9876 6.6623 17.6553 6.94575 19.3072C5.87854 19.596 4.84428 20.0027 3.84299 20.4667ZM5.52522 22.3349C5.43952 22.2571 4.96953 21.8062 4.94777 21.7548C4.91152 21.6697 4.9781 21.6836 5.01369 21.6658C5.71176 21.3125 6.57529 21.0943 7.31555 20.8346L8.26279 24.1489C7.29709 23.7099 6.31096 23.0487 5.52522 22.3349ZM12.7366 25.3598C11.9206 25.3401 11.0636 25.2155 10.2911 24.9373C9.70178 23.4779 9.16982 21.9861 8.84023 20.443C10.1138 20.1358 11.4255 19.9763 12.7366 19.9407V25.3598ZM12.7366 18.362C11.3003 18.3903 9.87382 18.5894 8.47373 18.888C8.23115 17.3725 8.06635 15.8465 7.99978 14.3107H12.7366V18.362ZM12.7366 12.7326H7.99978C8.06635 11.196 8.23115 9.67069 8.47373 8.15524C9.87382 8.45385 11.3003 8.65292 12.7366 8.68126V12.7326ZM12.7366 7.10253C11.4255 7.06693 10.1138 6.90741 8.84023 6.60023C9.16982 5.0571 9.70178 3.56537 10.2911 2.10595C11.0636 1.82777 11.9206 1.70319 12.7366 1.68341V7.10253ZM20.627 3.9767C20.983 4.23905 21.8208 4.89889 22.0535 5.23441C22.0845 5.27858 22.1267 5.28649 22.1049 5.36559L19.7371 6.20868L18.7899 2.89367C18.8729 2.806 20.4563 3.85146 20.627 3.9767ZM14.316 1.68341C14.409 1.59047 16.6251 1.94577 16.7616 2.10595C17.3509 3.56537 17.8829 5.0571 18.2124 6.60023C16.9389 6.90741 15.6271 7.06693 14.316 7.10253V1.68341ZM14.316 8.68126C15.7524 8.65292 17.1789 8.45385 18.5783 8.15524C18.8215 9.67069 18.9863 11.196 19.0529 12.7326H14.316V8.68126ZM16.7616 24.9373C15.989 25.2155 15.1321 25.3401 14.316 25.3598V19.9407C15.6271 19.9763 16.9389 20.1358 18.2124 20.443C17.8829 21.9861 17.3509 23.4779 16.7616 24.9373ZM14.316 18.362V14.3107H19.0529C18.9863 15.8465 18.8215 17.3725 18.5783 18.888C17.1789 18.5894 15.7524 18.3903 14.316 18.362ZM21.5795 22.2821C20.7832 23.0204 19.778 23.7 18.7899 24.1489L19.7371 20.8346L22.1049 21.677C22.1557 21.7462 21.6613 22.2063 21.5795 22.2821ZM23.2097 20.4667C22.2084 20.0027 21.1741 19.596 20.1069 19.3072C20.3897 17.6553 20.5624 15.9876 20.6316 14.3107H25.3685C25.294 16.5308 24.4358 18.6467 23.2097 20.4667ZM20.6316 12.7326C20.5624 11.0556 20.3897 9.38791 20.1069 7.736C21.1741 7.44728 22.2084 7.04057 23.2097 6.5765C24.4358 8.3965 25.294 10.5125 25.3685 12.7326H20.6316Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_723_6728">
        <rect width="27" height="27" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MenuIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
  </svg>
);

const CloseIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
  </svg>
);

// ================================
// HEADER COMPONENT
// ================================
const Header = ({ onContactClick, className = "" }) => {
  const citiesArray = Object.values(CITIES_DATA);
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();

  const whatsapp = phoneWhatsapp || "";

  // Filtra cidades de acordo com o contexto
  const CitiesFilter = citiesArray.filter(c => {
    const ctx = theme?.context?.toLowerCase() || "";
    if (ctx === "") return true;
    if (ctx.includes("respirat")) return c.cpap === true;
    if (ctx.includes("home")) return c.home === true;
    if (ctx.includes("audit")) return c.aud === true;
    return false;
  });

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const { entryCity } = useEntryTracking();
  const cityToDisplay = entryCity;

  const [selectedCity, setSelectedCity] = useState("");

  // Controle de scroll do header
  useEffect(() => {
    const handleScroll = () => {
      const current = window.scrollY;
      if (current > scrollY && current > 80) setIsVisible(false);
      else setIsVisible(true);
      setScrollY(current);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollY]);

  useEffect(() => setIsMenuOpen(false), [location.pathname]);

  const cities = Object.values(CITIES_DATA);

  // ================================
  // NOVO DROPDOWN DE CIDADES
  // ================================
  const CityDropdown = ({ className }) => {
    const handleChange = (e) => {
      const id = e.target.value;
      setSelectedCity(id);

      if (!id) return;

      navigate(`/city/${id}`);
      setIsMenuOpen(false);
    };

    return (
      <div className={className}>
        <div
          className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-md text-white ${theme.buttonBg}`}
        >
          <GlobeIcon />
          {
            !cityToDisplay ? <select
              value={selectedCity}
              onChange={handleChange}
              className="bg-transparent text-white outline-none cursor-pointer"
            >
              <option value="">
                Onde nos encontrar
              </option>
              {CitiesFilter.map((cityFilter) => (
                <option
                  key={cityFilter.id}
                  selected={cityFilter.id === entryCity?.id}
                  value={cityFilter.id}
                  className="text-black"
                >
                  {cityFilter.name}
                </option>
              ))}
            </select>
              :
              <a className="font-medium" href={`https://wa.me/${phoneWhatsapp}?text=${encodeURIComponent(`Olá, tudo bem? Eu estava na página "Auditivo - Bianco Azure" e gostaria de conversar com vocês.`)}`}>Fale Conosco Agora</a>}
        </div>
      </div>
    );
  };


  // Nav normal
  const NavLinks = ({ className, itemClasses, buttonMode }) => (
    <nav className={className}>
      {
        //<a href="/blog" className={itemClasses}>Blog</a>
      }
      <Link to={`${theme.linkPrefix || ""}/sobre`} className={itemClasses}>Sobre Nós</Link>
      {
        //  <Link to="/contact" className={itemClasses} onClick={() => buttonMode && setIsMenuOpen(false)}>
        //  Contato
        //</Link>
      }
    </nav>
  );

  const NavLinksHomeCare = ({ className, itemClasses, buttonMode }) => (
    <nav className={className}>
      <Link to={`https://wa.me/${whatsapp}?text=${encodeURIComponent("Gostaria de solicitar um orçamento")}`} className={itemClasses} onClick={() => buttonMode && setIsMenuOpen(false)}>
        Orçamentos
      </Link>
    </nav>
  );

  const containerBg = theme.bgColor ?? "bg-white/80";
  const containerBackdrop = theme.backdrop ?? "backdrop-blur-sm rounded-md";
  const logoTextClass = theme.textColor ?? "text-[#00394F]";
  const navTextClass = theme.navTextColor ?? "text-gray-600";
  const navHoverClass = theme.hoverTextColor ?? "hover:text-[#00394F]";

  return (
    <header
      className={`fixed top-0 w-full z-[999] p-4 transition-transform duration-500 ease-in-out ${className} ${isVisible ? "translate-y-0" : "-translate-y-full"}`}
    >
      {/* CONTAINER PRINCIPAL */}
      <div
        className={`flex justify-between items-center max-w-7xl mx-auto px-4 sm:px-6 md:px-10 lg:px-16 py-3 md:py-5 ${containerBg} ${containerBackdrop} shadow-lg`}
      >

        {/* LOGO */}
        <Link to="/" className={logoTextClass}>
          <div className="text-xl md:text-2xl font-bold tracking-wider">BIANCO AZURE</div>
          {theme.context && <h1 className="hidden md:block text-sm">{theme.context}</h1>}
        </Link>

        {/* NAV DESKTOP */}
        {theme.context === "" && (
          <NavLinks
            className="hidden md:flex items-center gap-6 lg:gap-8"
            itemClasses={`${navTextClass} transition-colors ${navHoverClass}`}
          />
        )}

        {theme.context === "homecare" && (
          <NavLinksHomeCare
            className="hidden md:flex items-center gap-6 lg:gap-8"
            itemClasses={`${navTextClass} transition-colors ${navHoverClass}`}
          />
        )}

        {/* DROPDOWN CIDADES (DESKTOP) */}
        <CityDropdown className="hidden md:flex" />

        {/* MENU MOBILE */}
        <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <CloseIcon className={`w-6 h-6 ${logoTextClass}`} /> : <MenuIcon className={`w-6 h-6 ${logoTextClass}`} />}
        </button>
      </div>

      {/* DROPDOWN MOBILE */}
      <div
        className={`md:hidden ${isMenuOpen ? "flex" : "hidden"} flex-col items-center gap-4 py-4 px-4 bg-white/95 backdrop-blur-sm rounded-b-lg shadow-lg max-w-7xl mx-auto`}
      >
        {theme.context === null && (
          <NavLinks
            className="flex flex-col items-center gap-4 w-full"
            itemClasses="text-[#00394F] font-medium w-full text-center py-2 border-b border-gray-200 hover:text-blue-600"
            buttonMode
          />
        )}

        {theme.context === "homecare" && (
          <NavLinksHomeCare
            className="flex flex-col items-center gap-4 w-full"
            itemClasses="text-[#00394F] font-medium w-full text-center py-2 border-b border-gray-200"
            buttonMode
          />
        )}

        {/* DROPDOWN MOBILE */}
        <CityDropdown className="w-full justify-center mt-2" />
      </div>

      {/* MARQUEE */}
      {cityToDisplay && <LocationMarquee city={cityToDisplay} />}
    </header>
  );
};

export default Header;
